module.exports = __webpack_public_path__ + "static/testimonies-ed66e28933c03d96334b4edd36e7748c.jpg";